import { combineReducers } from 'redux';
import { firebaseReducer } from 'react-redux-firebase';
import { firestoreReducer } from 'redux-firestore';

import AuthSignInReducer from './Auth/AuthSignInReducer';
import AuthForgotPasswordReducer from './Auth/AuthForgotPasswordReducer';
import AuthResetPasswordReducer from './Auth/AuthResetPasswordReducer';
import AuthWelcomeSetPasswordReducer from './Auth/AuthWelcomeSetPasswordReducer';
import SiderReducer from './Sider/SiderReducer';
import FilterReducer from './Filter/FilterReducer';
import ProfileEditReducer from './Profile/ProfileEditReducer';
import ProfileCompanyEditReducer from './Profile/ProfileCompanyEditReducer';
import ProfileCompanyBillingEditReducer from './Profile/ProfileCompanyBillingEditReducer';
import UserEditReducer from './User/UserEditReducer';
import UserDeleteReducer from './User/UserDeleteReducer';
import UsersInviteReducer from './User/UsersInviteReducer';
import DataSourceAddReducer from './DataSource/DataSourceAddReducer';
import DataSourceDeleteReducer from './DataSource/DataSourceDeleteReducer';
import DataAnnotationPhotoDocumentReserveReducer from './DataAnnotation/DataAnnotationPhotoDocumentReserveReducer';
import DataAnnotationPhotoDocumentSaveReducer from './DataAnnotation/DataAnnotationPhotoDocumentSaveReducer';
import DataAnnotationPhotoDocumentFinishReducer from './DataAnnotation/DataAnnotationPhotoDocumentFinishReducer';
import DataAnnotationPhotoDocumentReleaseReducer from './DataAnnotation/DataAnnotationPhotoDocumentReleaseReducer';
import DataAnnotationPhotoDocumentDeleteReducer from './DataAnnotation/DataAnnotationPhotoDocumentDeleteReducer';
import ViewerPhotoDocumentRelabelReducer from './Viewer/ViewerPhotoDocumentRelabelReducer';
import ViewerPhotoDocumentRejectReducer from './Viewer/ViewerPhotoDocumentRejectReducer';
import ViewerPhotoDocumentDeleteReducer from './Viewer/ViewerPhotoDocumentDeleteReducer';
import ViewerPhotoDocumentsRelabelReducer from './Viewer/ViewerPhotoDocumentsRelabelReducer';
import ViewerPhotoDocumentsRejectReducer from './Viewer/ViewerPhotoDocumentsRejectReducer';
import ViewerPhotoDocumentsDeleteReducer from './Viewer/ViewerPhotoDocumentsDeleteReducer';
import AnnotationVerificationPhotoDocumentReserveReducer from './AnnotationVerification/AnnotationVerificationPhotoDocumentReserveReducer';
import AnnotationVerificationPhotoDocumentSaveReducer from './AnnotationVerification/AnnotationVerificationPhotoDocumentSaveReducer';
import AnnotationVerificationPhotoDocumentFinishReducer from './AnnotationVerification/AnnotationVerificationPhotoDocumentFinishReducer';
import AnnotationVerificationPhotoDocumentReleaseReducer from './AnnotationVerification/AnnotationVerificationPhotoDocumentReleaseReducer';

const reducers = {
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  authSignInStore: AuthSignInReducer,
  authForgotPasswordStore: AuthForgotPasswordReducer,
  authResetPasswordStore: AuthResetPasswordReducer,
  authWelcomeSetPasswordStore: AuthWelcomeSetPasswordReducer,
  siderStore: SiderReducer,
  filterStore: FilterReducer,
  profileEditStore: ProfileEditReducer,
  profileCompanyEditStore: ProfileCompanyEditReducer,
  profileCompanyBillingEditStore: ProfileCompanyBillingEditReducer,
  userEditStore: UserEditReducer,
  userDeleteStore: UserDeleteReducer,
  usersInviteStore: UsersInviteReducer,
  dataSourceAddStore: DataSourceAddReducer,
  dataSourceDeleteStore: DataSourceDeleteReducer,
  dataAnnotationPhotoDocumentReserveStore: DataAnnotationPhotoDocumentReserveReducer,
  dataAnnotationPhotoDocumentSaveStore: DataAnnotationPhotoDocumentSaveReducer,
  dataAnnotationPhotoDocumentFinishStore: DataAnnotationPhotoDocumentFinishReducer,
  dataAnnotationPhotoDocumentReleaseStore: DataAnnotationPhotoDocumentReleaseReducer,
  dataAnnotationPhotoDocumentDeleteStore: DataAnnotationPhotoDocumentDeleteReducer,
  viewerPhotoDocumentRelabelStore: ViewerPhotoDocumentRelabelReducer,
  viewerPhotoDocumentRejectStore: ViewerPhotoDocumentRejectReducer,
  viewerPhotoDocumentDeleteStore: ViewerPhotoDocumentDeleteReducer,
  viewerPhotoDocumentsRelabelStore: ViewerPhotoDocumentsRelabelReducer,
  viewerPhotoDocumentsRejectStore: ViewerPhotoDocumentsRejectReducer,
  viewerPhotoDocumentsDeleteStore: ViewerPhotoDocumentsDeleteReducer,
  annotationVerificationPhotoDocumentReserveStore: AnnotationVerificationPhotoDocumentReserveReducer,
  annotationVerificationPhotoDocumentSaveStore: AnnotationVerificationPhotoDocumentSaveReducer,
  annotationVerificationPhotoDocumentFinishStore: AnnotationVerificationPhotoDocumentFinishReducer,
  annotationVerificationPhotoDocumentReleaseStore: AnnotationVerificationPhotoDocumentReleaseReducer,
};

export default combineReducers(reducers);
